import { faUser, faComment } from "@fortawesome/free-solid-svg-icons";
import { isPositiveNumber, isDefinedString } from "et3-type-guards";
import { useNavigate } from "react-router-dom";
import { PAYMENT_LIMIT } from "../../../../constants/picker-entries-constants";
import i18n from "../../../../constants/i18n";
import getUserPaymentsStore from "../../../../stores/user-store/payments-store";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import React from "react";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const UserPaymentsForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  async function getData() {
    await getUserPaymentsStore().getUserPaymentByUserId();
    navigate({
      pathname: window.location.pathname,
      search: `?id=${getUserPaymentsStore().userIdInput.get()}`
    });
  }
  const navigate = useNavigate();

  const disabledUserID = !isPositiveNumber(
    getUserPaymentsStore().userIdInput.get()
  );
  const disabledTransactionID = !isDefinedString(
    getUserPaymentsStore().transactionIdInput.get()
  );
  const disabledInvoiceNumber = !isDefinedString(
    getUserPaymentsStore().invoiceNumberInput.get()
  );

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"number"}
          icon={faUser}
          label={i18n.get("USER_ID")}
          placeHolder={i18n.get("USER_ID")}
          value={getUserPaymentsStore().userIdInput.get()}
          onChoose={(value: number) => {
            getUserPaymentsStore().setUserIDInput(value);
          }}
          onBlur={() => {}}
          onEnter={getData}
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"text"}
          icon={faComment}
          label={i18n.get("TRANSACTION_ID")}
          placeHolder={i18n.get("TRANSACTION_ID")}
          value={getUserPaymentsStore().transactionIdInput.get()}
          onChoose={(value: string) =>
            getUserPaymentsStore().transactionIdInput.set(value)
          }
          onBlur={() => {}}
          onEnter={() => {}}
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          type={"text"}
          icon={faComment}
          label={i18n.get("INVOICE_NUMBER")}
          placeHolder={i18n.get("INVOICE_NUMBER")}
          value={getUserPaymentsStore().invoiceNumberInput.get()}
          onChoose={(value: string) =>
            getUserPaymentsStore().setInvoiceNumber(value)
          }
          onBlur={() => {}}
          onEnter={() => {}}
          style={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={PAYMENT_LIMIT}
          value={getUserPaymentsStore().paymentLimit.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getUserPaymentsStore().setPaymentLimit(value);
          }}
          onEnter={() => {}}
          onClick={() => {}}
          isMultiple={false}
          style={{}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={45}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Button
          onClick={getData}
          isEnabled={!disabledUserID}
          size="LARGE"
          text="SEARCH_BY_USER_ID"
          type="GET"
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Button
          onClick={async () =>
            await getUserPaymentsStore().getUserPaymentByTransactionId()
          }
          isEnabled={!disabledTransactionID}
          size="LARGE"
          text="SEARCH_BY_TRANSACTION_ID"
          type="GET"
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Button
          onClick={async () =>
            await getUserPaymentsStore().getUserPaymentByInvoiceNumber()
          }
          isEnabled={!disabledInvoiceNumber}
          size="LARGE"
          text="SEARCH_BY_INVOICE_NUMBER"
          type="GET"
        />
      </ET3Div>
    </React.Fragment>
  );
});
export default UserPaymentsForm;
